import { Action } from "../../../types/state/action";
import {
  IMasterArtworkRequestHistory,
  MasterArtworkCollectionState,
} from "../collections/data.type";
import { IRequestStatusReason } from "../../../types/data.interface";
import { MasterArtworkNameState } from "../artwork-name/data.type";

type ValueOrNull<T> = T | null;
export type Option<T> = { value: T; label: string };

export type MasterArtworkNumberState = {
  id: ValueOrNull<number | string>;
  code: string;

  artwork_name: ValueOrNull<any>;
  collection: ValueOrNull<MasterArtworkCollectionState>;

  file_name: ValueOrNull<string>;
  requestId: string;
  requestStatus: ValueOrNull<string>;
  requestDateFrom: string;
  requestDateTo: string;
  requestor: string;
  launch_date: string;

  requestHistory: ValueOrNull<IMasterArtworkRequestHistory>;

  status?: string;
  comment?: string;

  submitComment: string;
  approveComment: string;
  rejectComment: string;
  rejectReason: IRequestStatusReason | null;

  hasUnsavedChanges: boolean;
  isValid: ValueOrNull<boolean>;
  isReadOnly: boolean;
};

export enum MasterArtworkNumberActionTypes {
  SET_ARTWORK_NUMBER = "masterArtworkNumber/setArtworkNumber",
  RESET_STATE = "masterArtworkNumber/resetState",

  SET_CODE = "masterArtworkNumber/setCode",
  SET_ARTWORK_NAME = "masterArtworkNumber/setArtworkName",
  SET_COLLECTION = "masterArtworkNumber/setCollection",
  SET_FILE_NAME = "masterArtworkNumber/setFileName",
  SET_STATUS = "masterArtworkNumber/setStatus",
  SET_COMMENT = "masterArtworkNumber/setComment",
  SET_ID = "masterArtworkNumber/setId",
  SET_LAUNCH_DATE = "masterArtworkNumber/setLaunchDate",

  SET_SUBMIT_COMMENT = "masterArtworkNumber/setSubmitComment",
  SET_APPROVE_COMMENT = "masterArtworkNumber/setApproveComment",
  SET_REJECT_COMMENT = "masterArtworkNumber/setRejectComment",
  SET_REJECT_REASON = "masterArtworkNumber/setRejectReason",
  SET_ARTWORK_NUMBER_FILE_NAME = "masterArtworkNumber/setArtworkNumberFileName",
  SET_IS_VALID = "masterArtworkNumber/setIsValid",
  SET_REQUEST_STATUS = "masterArtworkNumber/setRequestStatus",
  SET_UNSAVED_CHANGES = "masterArtworkNumber/setUnsavedChanges",
  SET_IS_READ_ONLY = "masterArtworkNumber/setIsReadOnly",
}

export type MasterArtworkNumberActionType = Action<
  MasterArtworkNumberActionTypes,
  Partial<MasterArtworkNumberState>
>;
